import { Route, Routes } from "react-router-dom";
import AdminSidebar from "../../components/admin-sidebar";
import "../../style/dashboard.css";
import ManageProduct from "./product-cms";
import CreateProduct from "./createproduct";
import ProductDetail from "./detail/[id]";
import Message from "./message";
import DetailMessage from "./messagedetail/[message_id]";
import CategoryDetail from "./categorydetail/[category_id]";
import SubcategoryDetail from "./subcategorydetail/[subcategory_id]";

const Dashboard = () => {

  return (
    <>
    <div className="feature-restrict-label">
        <p>This feature is not supported for mobile devices yet!</p>
      </div>
    <div className="dashboard-container">
      <AdminSidebar />
      <div className="dashboard-right-side">
        <div className="dashboard-right-side-layout">
        <Routes>
          <Route path="*" element={<ManageProduct />} />
          <Route path="createproduct" element={<CreateProduct />} />
          <Route path="detail/:id" element={<ProductDetail />} />
          <Route path="categorydetail/:category_id" element={<CategoryDetail />} />
          <Route path="subcategorydetail/:subcategory_id" element={<SubcategoryDetail />} />
          <Route path="message" element={<Message/>} />
          <Route path="message/:message_id" element={<DetailMessage/>} />
        </Routes>
        </div>
       
      </div>
    </div>
    </>
  );
};

export default Dashboard;
